import { defineMessages } from 'react-intl';

/** The copy of the music video field of the song page Details (design music-video g1, g2). */
export const musicVideoFieldMessages = defineMessages({
  label: { id: 'app.sml.musicVideo.field.label', defaultMessage: 'Music video' },
  empty: { id: 'app.sml.musicVideo.field.empty', defaultMessage: 'No music video yet' },
  addYourVideo: { id: 'app.sml.musicVideo.field.addYourVideo', defaultMessage: 'Add your video' },
  makeOne: { id: 'app.sml.musicVideo.field.makeOne', defaultMessage: 'Make one' },
  hintNone: {
    id: 'app.sml.musicVideo.field.hintNone',
    defaultMessage: 'Already on YouTube? Link it. Or make one from the clip bank, AI clips and your own footage.',
  },
  labelYouTube: { id: 'app.sml.musicVideo.field.labelYouTube', defaultMessage: 'Linked from YouTube' },
  labelFile: { id: 'app.sml.musicVideo.field.labelFile', defaultMessage: 'Your file' },
  labelMade: { id: 'app.sml.musicVideo.field.labelMade', defaultMessage: 'Made in the editor' },
  openOnYouTube: { id: 'app.sml.musicVideo.field.openOnYouTube', defaultMessage: 'Open on YouTube' },
  change: { id: 'app.sml.musicVideo.field.change', defaultMessage: 'Change' },
  hintYouTube: {
    id: 'app.sml.musicVideo.field.hintYouTube',
    defaultMessage: 'Upload the file too, and the Studio can cut posts from it.',
  },
  uploadFileToo: { id: 'app.sml.musicVideo.field.uploadFileToo', defaultMessage: 'Upload the file too' },
  replace: { id: 'app.sml.musicVideo.field.replace', defaultMessage: 'Replace' },
  replaceWithFile: { id: 'app.sml.musicVideo.field.replaceWithFile', defaultMessage: 'Replace with a file' },
  download: { id: 'app.sml.musicVideo.field.download', defaultMessage: 'Download' },
  hintFile: { id: 'app.sml.musicVideo.field.hintFile', defaultMessage: 'Publish it on YouTube from the Kit.' },
  madeLine: { id: 'app.sml.musicVideo.field.madeLine', defaultMessage: 'Made in the music video editor' },
  editVideo: { id: 'app.sml.musicVideo.field.editVideo', defaultMessage: 'Edit the video' },
  making: { id: 'app.sml.musicVideo.field.making', defaultMessage: 'Making the video…' },
  failed: {
    id: 'app.sml.musicVideo.field.failed',
    defaultMessage: 'The video could not be made. Your credits are back. Open the editor to try again.',
  },
  badgeFile: { id: 'app.sml.musicVideo.field.badgeFile', defaultMessage: 'Your file' },
  badgeFileSize: { id: 'app.sml.musicVideo.field.badgeFileSize', defaultMessage: 'Your file · {size}' },
  badgeCut: { id: 'app.sml.musicVideo.field.badgeCut', defaultMessage: 'Cut {number}' },
  badgeYouTubeViews: {
    id: 'app.sml.musicVideo.field.badgeYouTubeViews',
    defaultMessage: '{count, plural, one {{channel} · # view} other {{channel} · # views}}',
  },
  play: { id: 'app.sml.musicVideo.field.play', defaultMessage: 'Play the music video' },
  playFailed: { id: 'app.sml.musicVideo.field.playFailed', defaultMessage: 'The video does not play now. Try again.' },
  chipNone: { id: 'app.sml.musicVideo.field.chipNone', defaultMessage: 'No music video' },
  chipReady: { id: 'app.sml.musicVideo.field.chipReady', defaultMessage: 'Music video ready' },
  soundMismatch: {
    id: 'app.sml.musicVideo.field.soundMismatch',
    defaultMessage: 'The sound is not {title}. Is it the right file?',
  },
});
